namespace gotoAndPlay {

    function onInit(): void {
        // gallery code
    }

    $(document).ready(onInit);
}
